(function () {
  function getGermanHolidays(year) {
    const fixed = [
      `${year}-01-01`,
      `${year}-05-01`,
      `${year}-10-03`,
      `${year}-12-25`,
      `${year}-12-26`,
    ];

    function easterDate(y) {
      const a = y % 19, b = Math.floor(y / 100), c = y % 100;
      const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      const day = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(y, month - 1, day);
    }

    const easter = easterDate(year);
    const addD = (d, n) => { const r = new Date(d); r.setDate(r.getDate() + n); return r; };
    const fmt = d => d.toISOString().split('T')[0];

    const movable = [
      fmt(addD(easter, -2)),
      fmt(addD(easter, 1)),
      fmt(addD(easter, 39)),
      fmt(addD(easter, 50)),
      fmt(addD(easter, 60)),
    ];

    return new Set([...fixed, ...movable]);
  }

  function isBusinessDay(date) {
    const day = date.getDay();
    if (day === 0 || day === 6) return false;
    const holidays = getGermanHolidays(date.getFullYear());
    return !holidays.has(date.toISOString().split('T')[0]);
  }

  function addBusinessDays(startDate, days) {
    let date = new Date(startDate);
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (isBusinessDay(date)) added++;
    }
    return date;
  }

  function formatDate(date) {
    const days = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    return `${days[date.getDay()]}, ${d}.${m}.`;
  }

  function renderDelivery() {
    const elements = document.querySelectorAll('[data-vco-delivery-date]');
    if (!elements.length) return;

    const today = new Date();
    const earliest = addBusinessDays(today, 4);
    const latest = addBusinessDays(today, 6);
    const text = `${formatDate(earliest)} \u2013 ${formatDate(latest)}`;

    elements.forEach(el => el.textContent = text);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderDelivery);
  } else {
    renderDelivery();
  }

  document.addEventListener('instant:rendered', renderDelivery);
})();